<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <el-form :model="query" @submit.native.prevent>
                    <el-row>
                        <el-select v-model="query.news_type" placeholder="订单类型" class="handle-input mr10">
                            <el-option v-for="item in planNewsTypeList" :key="item.id" :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.supplier_id" collapse-tags placeholder="供应商" filterable clearable
                            class="handle-input mr10">
                            <el-option v-for="(item, index) in supplierList" :key="index" :label="item.title"
                                :value="item.id + ''"></el-option>
                        </el-select>
                        <el-select v-model="query.company_id" multiple collapse-tags placeholder="执行公司" filterable
                            clearable class="handle-input mr10">
                            <el-option v-for="(item, index) in dictionary.getPicker('company')" :key="index"
                                :label="item.title" :value="item.id + ''"></el-option>
                        </el-select>
                        <el-select v-model="query.category_id" placeholder="四大类型" multiple filterable clearable
                            class="handle-input mr10">
                            <el-option v-for="(item, index) in four" :key="index" :label="item.title"
                                :value="item.id + ''"></el-option>
                        </el-select>
                        <el-date-picker class="daterange mr10" v-model="query.date_range" type="daterange"
                            value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                        <el-select v-model="query.hotel_id" placeholder="举办酒店" class="handle-input mr10" filterable
                            clearable>
                            <el-option v-for="(item, index) in dictionary.getPicker('hotel')" :key="index"
                                :label="item.title" :value="item.id + ''"></el-option>
                        </el-select>
                    </el-row>
                    <el-row>
                        <user-by-role v-model="query.planer_id" placeholder="请选择策划师" :roles="[32, 35]"
                            class="mr10"></user-by-role>
                        <el-input v-model="query.keywords" placeholder="手机号/客户姓名/微信号" clearable
                            class="handle-input mr10"></el-input>
                        <el-select v-model="query.settle_status" placeholder="请选择结算状态" class="handle-input mr10"
                            filterable clearable>
                            <el-option v-for="(item, index) in settleStatus" :key="index" :label="item.title"
                                :value="item.id"></el-option>
                        </el-select>
                        <el-button type="primary" class="btn-search ml8" @click="searchTableData">搜索</el-button>
                        <el-button type="success" class="btn-search ml8" @click="download">导出</el-button>
                        <el-popover placement="bottom" width="600" trigger="click">
                            <div class="help-container">
                                <div>
                                    <el-tag type="danger">已分配状态</el-tag>
                                    <dl class="help-box">
                                        <dt>待分配:</dt>
                                        <dd>策划师未提交需求</dd>
                                    </dl>
                                    <dl class="help-box">
                                        <dt class="w150">已分配-[待审核]:</dt>
                                        <dd>发起申请等待审核</dd>
                                    </dl>
                                    <dl class="help-box">
                                        <dt class="w150">已分配-[审核驳回]:</dt>
                                        <dd>审核通过总监已配发某摄影师/化妆师/司仪/摄影摄像</dd>
                                    </dl>
                                    <dl class="help-box">
                                        <dt class="w150">已分配-[审核通过]:</dt>
                                        <dd>派发某摄影师/化妆师/司仪/摄影摄像已点击确定</dd>
                                    </dl>
                                </div>
                                <div>
                                    <el-tag type="danger">已派单状态</el-tag>
                                    <dl class="help-box">
                                        <dt class="w150">已派单-[待审核]:</dt>
                                        <dd>已派单-[待审核]</dd>
                                    </dl>
                                    <dl class="help-box">
                                        <dt class="w150">已派单-[审核驳回]:</dt>
                                        <dd>已派单-[审核驳回]</dd>
                                    </dl>
                                    <dl class="help-box">
                                        <dt class="w150">已派单-[审核通过]:</dt>
                                        <dd>已派单-[审核通过]</dd>
                                    </dl>
                                </div>
                                <div>
                                    <el-tag type="danger">已确认状态</el-tag>
                                    <dl class="help-box">
                                        <dt class="w150">已确认:</dt>
                                        <dd>已确认</dd>
                                    </dl>
                                </div>
                                <div>
                                    <el-tag type="danger">重新派单中状态</el-tag>
                                    <dl class="help-box">
                                        <dt class="w152">重新派单中-[待审核]:</dt>
                                        <dd>重新派单中-[待审核]</dd>
                                    </dl>
                                    <dl class="help-box">
                                        <dt class="w152">重新派单中-[审核驳回]:</dt>
                                        <dd>重新派单中-[审核驳回]</dd>
                                    </dl>
                                    <dl class="help-box">
                                        <dt class="w152">重新派单中-[审核通过]:</dt>
                                        <dd>重新派单中-[审核通过]</dd>
                                    </dl>
                                </div>
                                <div>
                                    <el-tag type="danger">已作废状态</el-tag>
                                    <dl class="help-box">
                                        <dt class="w150">已作废-[待审核]:</dt>
                                        <dd>已作废-[待审核]</dd>
                                    </dl>
                                    <dl class="help-box">
                                        <dt class="w150">已作废-[审核驳回]:</dt>
                                        <dd>已作废-[审核驳回]</dd>
                                    </dl>
                                    <dl class="help-box">
                                        <dt class="w150">已作废-[审核通过]:</dt>
                                        <dd>已作废-[审核通过]</dd>
                                    </dl>
                                </div>
                            </div>

                            <el-button slot="reference" class="ml8" type="danger">注解</el-button>
                        </el-popover>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 搜索E -->
        <div class="nav-check-status">
            <el-radio-group v-model="query.status" @change="changeHandler">
                <el-radio-button label="0">待分配</el-radio-button>
                <el-radio-button label="1">已派单</el-radio-button>
                <el-radio-button label="2">已确认</el-radio-button>
                <el-radio-button label="3">重新派单中</el-radio-button>
                <el-radio-button label="4">已作废</el-radio-button>
                <el-radio-button label="">全部</el-radio-button>
            </el-radio-group>
        </div>

        <el-table :data="tableData" border :height="tableHeight" :max-height="tableHeight" v-loading="loading">
            <el-table-column prop="status" label="派单状态" align="center">
                <template slot-scope="scope">
                    <el-link type="danger" @click="showDrawerPass(_self, 'detailView', 'showDrawer', [scope.row])"
                        v-if="scope.row.status == 0 && scope.row.supplier_id == 0">待分配</el-link>
                    <el-link type="danger" @click="showDrawerPass(_self, 'detailView', 'showDrawer', [scope.row])"
                        v-if="scope.row.status == 0 && scope.row.supplier_id > 0">已分配-[{{ getItemCheckTitle(scope.row.item_check_status1) }}]</el-link>
                    <el-link type="danger" @click="showDrawerPass(_self, 'detailView', 'showDrawer', [scope.row])"
                        v-else-if="scope.row.status == 1">已派单-[{{ getItemCheckTitle(scope.row.item_check_status1) }}]</el-link>
                    <el-link type="danger" @click="showDrawerPass(_self, 'detailView', 'showDrawer', [scope.row])"
                        v-else-if="scope.row.status == 2">已确定</el-link>
                    <el-link type="danger" @click="showDrawerPass(_self, 'detailView', 'showDrawer', [scope.row])"
                        v-else-if="scope.row.status == 3">重新派单中-[{{ getItemCheckTitle(scope.row.item_check_status1) }}]</el-link>
                    <el-link type="danger" @click="showDrawerPass(_self, 'detailView', 'showDrawer', [scope.row])"
                        v-else-if="scope.row.status == 4">已作废-[{{ getItemCheckTitle(scope.row.item_check_status2) }}]</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="category.title" label="类型" width="80" align="center"></el-table-column>
            <el-table-column prop="supplier" label="团队">
                <template slot-scope="scope">
                    <el-link type="danger" v-if="scope.row.supplier_id == 0">待分配</el-link>
                    <span v-else>{{ scope.row.supplier }}</span>
                </template>
            </el-table-column>

            <el-table-column prop="product" label="人员" show-overflow-tooltip></el-table-column>
            <el-table-column prop="wedding.company" label="承办公司" show-overflow-tooltip></el-table-column>
            <el-table-column prop="order.event_date" label="婚期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="order.hotel" label="酒店" show-overflow-tooltip></el-table-column>
            <el-table-column prop="hall" label="厅" show-overflow-tooltip></el-table-column>
            <el-table-column prop="order.bridegroom" label="客户姓名"></el-table-column>
            <el-table-column prop="planner" label="策划师"></el-table-column>
            <!-- <el-table-column prop="allocate_time" label="分配时间" align="center"></el-table-column> -->
            <el-table-column prop="wedding.wedding_totals" label="套餐金额" align="center"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
            <el-table-column label="结算">
                <template slot-scope="scope">
                    <el-link type="success" v-if="scope.row.settle_status == 1">结算中</el-link>
                    <el-link type="success" v-if="scope.row.settle_status == 2">结算通过</el-link>
                    <el-link type="warning" v-if="scope.row.settle_status == 3">结算驳回</el-link>
                    <el-link type="danger" v-if="!scope.row.settle_status">待结算</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="特殊要求" show-overflow-tooltip></el-table-column>
        </el-table>

        <!-- 底部操作栏 -->
        <div class="footer-box">
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.page" :page-sizes="[15, 20, 50, 100]" :page-size="pagination.limit"
                    layout="total, sizes, prev, pager, next, jumper" :total="pagination.totals"></el-pagination>
            </div>
        </div>

        <detail-view ref="detailView" :parent="_self"></detail-view>
    </div>
</template>

<script>
import {
    showDrawerPass,
    getItemCheckTitle
} from '@/utils/common.js';
import dictionary from '@/utils/dictionary';
import userByRole from '@/components/picker/userByRole.vue'

import detailView from './detail.vue';
const query = {
    news_type: "1",
    supplier_id: "",
    company_id: "",
    hotel_id: "",
    planer_id: "",
    date_range: [],
    keywords: "", //手机号/客户姓名/微信号
    status: "0",
    title: "",
    category_id: [],
    settle_status: ""
};
export default {
    namespaced: true,
    name: 'fourOrder',
    components: {
        detailView,
        userByRole
    },
    data() {
        let tableHeight = window.innerHeight - 320;
        let windowheight = window.innerHeight;
        return {
            supplierList: [],
            plannerList: [],
            query: Object.assign({}, query), // 搜索条件
            tableData: [],
            tableHeight: tableHeight,
            windowheight: windowheight,
            pagination: {
                page: 1,
                limit: 15,
                totals: 0
            },
            loading: false,
            four: [{
                id: '5',
                title: '司仪'
            },
            {
                id: '26',
                title: '化妆'
            },
            {
                id: '3',
                title: '摄影'
            },
            {
                id: '4',
                title: '摄像'
            }
            ],
            settleStatus: [{
                id: '1',
                title: '结算中'
            },
            {
                id: '2',
                title: '审核中'
            },
            {
                id: '3',
                title: '结算驳回'
            },
            {
                id: '',
                title: '待结算'
            }
            ]
        };
    },
    computed: {
        planNewsTypeList() {
            let planList = [{
                id: "1",
                title: "婚庆信息"
            },
            {
                id: "7",
                title: "宝宝宴"
            },
            {
                id: "8",
                title: "会务"
            },
            {
                id: "11",
                title: "婚博会"
            },
            {
                id: "12",
                title: "婚礼秀"
            }
            ];

            return planList;
        }
    },
    beforeCreate() {
        this.dictionary = dictionary;
        this.showDrawerPass = showDrawerPass;
        this.getItemCheckTitle = getItemCheckTitle;
    },
    created() {
        this.getTableData();
        this.getSupplierList();
    },
    methods: {
        getSupplierList() {
            let _this = this;
            let url = '/api/supplier.company/index';
            this.$post(url, {
                category_parent_id: 1
            }).then(res => {
                if (res.code == '200') {
                    _this.supplierList = res.data.list;
                }
            });
        },
        changeHandler(value) {
            this.query.status = value;
            this.pagination.page = 1;
            this.getTableData();
        },
        searchTableData() {
            this.pagination.page = 1;
            this.getTableData();
        },
        getTableData() {
            let _this = this;
            _this.loading = true;
            let url = '/api/wedding.four/index';
            let query = this.query;
            query.pagination = _this.pagination;
            this.$post(url, query).then(res => {
                if (res.code == '200') {
                    _this.tableData = res.data.list;
                    _this.pagination = res.data.pagination;
                    _this.loading = false;
                }
            });
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        download() {
            let _this = this;
            let url = '/api/wedding.four/download';
            let options = _this.query;
            this.$post(url, options).then(res => {
                if (res.code == '200') {
                    let link = document.createElement('a');
                    link.href = res.data.url;
                    link.click();
                }
            });
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
